import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { NarrowNavItems, NarrowNavItemsProps } from "./NarrowNavItems"
import { PropsWithChildren } from "react"
import { tailwindPalette } from "../../modules/theme/tailwindPalette"
import { whenPrintingPageOnly } from "../components/print/printPageOnly"

const useStyles = makeStyles()(() => ({
    container: {
        backgroundColor: tailwindPalette.blue[50],
        minHeight: "100vh",
        position: "relative",
        ...whenPrintingPageOnly({
            minHeight: "auto",
            printColorAdjust: "exact",
        }),
    },
    mainContent: {
        display: "flex",
        width: "100%",
    },
    pageContainer: {
        padding: "1rem 2rem",
        width: "100%",
        marginLeft: "7rem",
        ...whenPrintingPageOnly({
            padding: ".75rem 1.25rem 0",
            marginLeft: 0,
        }),
    },
}))

export function NarrowNavLayout({ navItems, children }: PropsWithChildren<NarrowNavItemsProps>) {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            {children}
            <Box className={classes.mainContent}>
                <NarrowNavItems navItems={navItems} />
                <Box className={classes.pageContainer}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}
